"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.125 9.39a.7.7 0 0 1-.208-.157h1.037a.7.7 0 0 1-.829.157M9.39 5.125a.7.7 0 0 1-.157.829V4.917a.7.7 0 0 1 .157.208M11.476 4a8 8 0 0 1 1.048 0 .7.7 0 0 1-.09 1.397 7 7 0 0 0-.868 0A.7.7 0 1 1 11.476 4m3.134 1.126a.7.7 0 0 1 .937-.317q.474.234.908.525a.7.7 0 0 1-.779 1.164 7 7 0 0 0-.749-.434.7.7 0 0 1-.317-.938m3.086 2.228a.7.7 0 0 1 .97.192q.292.435.526.908a.7.7 0 1 1-1.255.62 7 7 0 0 0-.434-.75.7.7 0 0 1 .193-.97m-12.953 3.47a.7.7 0 0 1 .653.743 7 7 0 0 0 0 .868.7.7 0 1 1-1.397.09 8 8 0 0 1 0-1.048.7.7 0 0 1 .744-.654m14.514 0a.7.7 0 0 1 .744.653 8 8 0 0 1 0 1.048.7.7 0 1 1-1.397-.09 7 7 0 0 0 0-.868.7.7 0 0 1 .653-.744M5.125 14.61a.7.7 0 0 1 .938.317q.193.39.433.75a.7.7 0 1 1-1.163.778 8 8 0 0 1-.525-.908.7.7 0 0 1 .317-.937m9.642 3.436a.7.7 0 0 0 0 1.037zm4.316-3.28a.7.7 0 0 0-1.037 0zm-11.73 2.93a.7.7 0 0 1 .97-.192q.36.24.75.433a.7.7 0 0 1-.62 1.255 8 8 0 0 1-.908-.525.7.7 0 0 1-.193-.971m3.47 1.561a.7.7 0 0 1 .743-.653 7 7 0 0 0 .868 0 .7.7 0 0 1 .09 1.397 8 8 0 0 1-1.048 0 .7.7 0 0 1-.654-.744",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 3.7a.7.7 0 0 1 .7-.7h5.533a.7.7 0 0 1 .7.7v5.533a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7zm1.4.7v4.133h4.133V4.4zm9.667 10.367a.7.7 0 0 1 .7-.7H20.3a.7.7 0 0 1 .7.7V20.3a.7.7 0 0 1-.7.7h-5.533a.7.7 0 0 1-.7-.7zm1.4.7V19.6H19.6v-4.133z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ProofCircleDashedIcon24.js.map